import Dialog from "../../atoms/dialog";
import { useState } from 'react'
import RemoveMember from "../teams/RemoveMember";

const RemoveMemberAlert = (props) => {

    const { onCompletion, memberToRemove, onClose } = props;
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
        onClose()
    }

    return (
        <Dialog
            open={open}
            handleClose={handleClose}
        >
            <RemoveMember onCompletion={onCompletion} memberToRemove={memberToRemove} onClose={handleClose} />
        </Dialog >
    )
}

export default RemoveMemberAlert;